
import { i18n } from "./I18n.js";
import { markPdfPending } from "./Widgets/PdfReady.js";
import { tokenKey } from "./Constants.js";
import { jwtDecode } from "jwt-decode";
import { parseCustomer } from "./Common.js";
import { roleFromString } from "./Shared/Helper.js";
import { RequestedValue$1, TokenDataDto, UserTentantConfiguration_$reflection, UserTentantConfiguration } from "./Shared/Shared.js";
import { uint64 as uint64_1, int64 as int64_1, decimal as decimal_1, Auto_generateBoxedDecoder_Z6670B51, fromString } from "./fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { comparePrimitives, uncurry3, Exception, createObj, equals, uncurry2 } from "./fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { makeUnion, getUnionCases, getUnionCaseFields, name as name_1, anonRecord_type, string_type, option_type, list_type } from "./fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { unwrap, map as map_1, flatten, defaultArg, ofNullable } from "./fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { ofArray, singleton as singleton_1, tryFind } from "./fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { debugActive } from "./Variant.js";
import { initializeSentry } from "./Sentry.js";
import { rememberCurrentRoute } from "./Widgets/Table/State.js";
import { RouterModule_router, RouterModule_nav, RouterModule_urlSegments } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { Url, AuthorizedUrl, parseUrl } from "./Routes.js";
import { now, toLocalTime, utcNow, date as date_2 } from "./fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { Msg_$reflection, State_$reflection, Msg, State } from "./Types.js";
import { Cmd_none, Cmd_ofEffect, Cmd_batch } from "./fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { map as map_2, empty, singleton, append, delay, toList } from "./fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { getHealth } from "./Requests/Health.js";
import { getCustomerConfiguration } from "./Requests/Configuration.js";
import { getAccountSettings } from "./Requests/Customer.js";
import { Cmd_OfPromise_either } from "./fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "./CommunicationV2.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "./fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { RolePermissionsDto_$reflection } from "./Shared/Roles.js";
import { ValidationOnGetRequest } from "./ErrorHandling.js";
import { activateIfNeeded } from "./WebPush.js";
import { canSeeDashboard, landingPage } from "./UserPermissions.js";
import { Cmd_ofEffect as Cmd_ofEffect_1 } from "./fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Helper_languageToString, User_$reflection, Requests_UserAccountExistsResponse_$reflection } from "./Shared/User.js";
import { last, map as map_3, item } from "./fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { uint64, int64, decimal, Auto_generateBoxedEncoder_437914C6, toString } from "./fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { hide } from "./HubSpotChat.js";
import i18next from "i18next";
import { HubSpotChatSettingsDto_$reflection } from "./Shared/Support.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useTranslation } from "react-i18next";
import { reactElement, reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { join } from "./fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { userManager } from "./Auth.js";
import { html5Backend } from "./Bindings/Feliz.DnDProvider.js";
import { localStorageProvider } from "./Bindings/Fable.Import.SWR.js";
import { Toaster } from "./Components/Toast.js";
import { ActivePage } from "./ActivePage.js";
import { reactApi as reactApi_1 } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ErrorBoundary } from "@sentry/react";
import { SWRConfig } from "swr";
import { LoadingPage } from "./LoadingPage.js";
import { DndProvider } from "react-dnd";
import { AuthProvider } from "react-oidc-context";
import { ProgramModule_run } from "./fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Program_withReactBatched } from "./fable_modules/Fable.Elmish.React.5.0.0/react.fs.js";
import { ProgramModule_mkProgram, ProgramModule_withConsoleTrace } from "./fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Debugger_getCase, Debugger_showWarning, Debugger_showError } from "./fable_modules/Fable.Elmish.Debugger.4.2.2/debugger.fs.js";
import { newGuid } from "./fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { ofSeq, FSharpMap__get_Item, add } from "./fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { empty as empty_1 } from "./fable_modules/Thoth.Json.10.4.1/Extra.fs.js";
import { ExtraCoders } from "./fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { fromValue } from "./fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { ProgramModule_setState, ProgramModule_map, ProgramModule_mapErrorHandler } from "./fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Sub_map, Sub_batch } from "./fable_modules/Fable.Elmish.5.0.2/sub.fs.js";
import { extractState } from "./fable_modules/Fable.Elmish.Debugger.4.2.2/Fable.Import.RemoteDev.fs.js";
import { defaultOf } from "./fable_modules/fable-library-js.5.0.0-rc.2/Util.js";


markPdfPending();

export function resetToken(_arg) {
    localStorage.removeItem(tokenKey);
    localStorage.removeItem("app-cache");
}

export function parseToken(token) {
    let matchValue;
    const decodedToken = jwtDecode(token);
    return new TokenDataDto(decodedToken.username, decodedToken.user_id, decodedToken.customer, parseCustomer(decodedToken.customer), new UserTentantConfiguration(decodedToken.customer, roleFromString(decodedToken.role)), (matchValue = fromString(uncurry2(Auto_generateBoxedDecoder_Z6670B51(option_type(list_type(UserTentantConfiguration_$reflection())), undefined, undefined)), decodedToken.tenants), (matchValue.tag === 1) ? undefined : matchValue.fields[0]), roleFromString(decodedToken.role));
}

export function readTenantFromLocalStorage(tokenData) {
    const tenant = ofNullable(localStorage.getItem("tenant"));
    let matchResult, tenant_1, tokenData_1;
    if (tokenData != null) {
        if (tenant != null) {
            matchResult = 0;
            tenant_1 = tenant;
            tokenData_1 = tokenData;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const patternInput = defaultArg(flatten(map_1((allowedTenants) => map_1((allowedTenant_1) => [allowedTenant_1.Role, allowedTenant_1.Tenant], tryFind((allowedTenant) => (allowedTenant.Tenant === tenant_1), allowedTenants)), tokenData_1.Tenants)), [tokenData_1.Role, tokenData_1.CustomerId]);
            const tenantCustomerId = patternInput[1];
            return new TokenDataDto(tokenData_1.UserName, tokenData_1.UserId, tenantCustomerId, parseCustomer(tenantCustomerId), tokenData_1.MainTenant, tokenData_1.Tenants, patternInput[0]);
        }
        default:
            return tokenData;
    }
}

export function getTokenDataFromLocalStorage(_arg) {
    const tokenData = map_1((arg) => parseToken(JSON.parse(arg).access_token), ofNullable(localStorage.getItem(tokenKey)));
    if (!debugActive) {
        initializeSentry(tokenData);
    }
    return readTenantFromLocalStorage(tokenData);
}

export function init() {
    rememberCurrentRoute();
    const currentUrl = RouterModule_urlSegments(window.location.hash, 1);
    const initialUrl = parseUrl(currentUrl);
    return [new State([false, date_2(utcNow())], initialUrl, new RequestedValue$1(0, []), new RequestedValue$1(0, []), new RequestedValue$1(0, []), new RequestedValue$1(0, []), new RequestedValue$1(0, []), new RequestedValue$1(0, []), new RequestedValue$1(0, []), false, false, undefined), Cmd_batch(toList(delay(() => append(singleton(getHealth((Item) => (new Msg(15, [Item])), (Item_1) => (new Msg(16, [Item_1])))), delay(() => (equals(currentUrl, singleton_1("login")) ? singleton(Cmd_ofEffect((_arg) => {
        window.location.hash = "#/";
    })) : empty()))))))];
}

export function update(msg, state) {
    let matchValue, userData, fullPath, matchValue_8, userData_1, userData_2, fullPath_14;
    switch (msg.tag) {
        case 1:
            return [state, (matchValue = state.UserData, (matchValue.tag === 1) ? ((matchValue.fields[0] != null) ? ((userData = matchValue.fields[0], Cmd_batch(ofArray([getCustomerConfiguration((Item_2) => (new Msg(7, [Item_2])), (Item_3) => (new Msg(16, [Item_3]))), getAccountSettings((Item_4) => (new Msg(8, [Item_4])), (Item_5) => (new Msg(16, [Item_5]))), Cmd_OfPromise_either((url_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_5;
                return ((url_5 = addPrefix(url_3), (refreshOn_1) => fetchWithDecoder(url_5, singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response_2) => {
                    const pr_1 = response_2.arrayBuffer();
                    return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), RolePermissionsDto_$reflection()));
                }, refreshOn_1)))(true).then((_arg_1) => {
                    const result_3 = _arg_1;
                    return (result_3.tag === 1) ? (Promise.resolve((() => {
                        throw new ValidationOnGetRequest(result_3.fields[0]);
                    })())) : (Promise.resolve(result_3.fields[0]));
                });
            })), "/api/users/me/permissions", (Item_6) => (new Msg(13, [Item_6])), (Item_7) => (new Msg(16, [Item_7]))), Cmd_ofEffect((_arg_2) => {
                activateIfNeeded();
            })])))) : Cmd_none()) : Cmd_none())];
        case 2: {
            const removeLoginParameter = Cmd_ofEffect((_arg_3) => {
                window.history.replaceState({}, document.title, window.location.pathname);
            });
            const matchValue_1 = state.UserData;
            const matchValue_2 = state.Permissions;
            let matchResult, permissions;
            if (matchValue_1.tag === 1) {
                if (matchValue_1.fields[0] != null) {
                    if (matchValue_2.tag === 0) {
                        matchResult = 1;
                    }
                    else {
                        matchResult = 0;
                        permissions = matchValue_2.fields[0];
                    }
                }
                else {
                    matchResult = 2;
                }
            }
            else {
                matchResult = 2;
            }
            switch (matchResult) {
                case 0:
                    return [state, Cmd_batch(ofArray([removeLoginParameter, (fullPath = landingPage(permissions), Cmd_ofEffect_1((_arg_4) => {
                        RouterModule_nav(singleton_1(fullPath), 1, 1);
                    }))]))];
                case 1:
                    return [new State(state.IsInTestphase, state.CurrentUrl, state.UserData, state.Configuration, state.AccountSettings, state.CurrentUser, state.Permissions, state.UserAccountExists, state.HealthFetched, state.OnboardingWizardCompleted, true, state.HubSpotChatSettings), removeLoginParameter];
                default:
                    return [state, removeLoginParameter];
            }
        }
        case 3:
            return [state, Cmd_OfPromise_either((url_6) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_8;
                return ((url_8 = addPrefix(url_6), (refreshOn_2) => fetchWithDecoder(url_8, singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response_4) => {
                    const pr_2 = response_4.arrayBuffer();
                    return pr_2.then((blob_2) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_2)), Requests_UserAccountExistsResponse_$reflection()));
                }, refreshOn_2)))(true).then((_arg_5) => {
                    const result_5 = _arg_5;
                    return (result_5.tag === 1) ? (Promise.resolve((() => {
                        throw new ValidationOnGetRequest(result_5.fields[0]);
                    })())) : (Promise.resolve(result_5.fields[0]));
                });
            })), "/api/users/account-exists", (Item_8) => (new Msg(10, [Item_8])), (Item_9) => (new Msg(16, [Item_9])))];
        case 4: {
            const matchValue_4 = tryFind((segment) => segment.startsWith("?"), RouterModule_urlSegments(window.location.hash, 1));
            if (matchValue_4 == null) {
                return [state, Cmd_none()];
            }
            else {
                const queryParams = matchValue_4;
                const token_1 = map_1((tuple) => tuple[1], tryFind((tupledArg) => (tupledArg[0] === "token"), toList(delay(() => map_2((entry) => [item(0, entry), item(1, entry)], (new URLSearchParams(queryParams)).entries())))));
                const tokenData_1 = readTenantFromLocalStorage(map_1(parseToken, token_1));
                if (!debugActive) {
                    initializeSentry(tokenData_1);
                }
                if (token_1 == null) {
                }
                else {
                    let token_4;
                    const arg = {
                        access_token: token_1,
                    };
                    token_4 = toString(0, Auto_generateBoxedEncoder_437914C6(anonRecord_type(["access_token", string_type]), undefined, undefined, undefined)(arg));
                    localStorage.setItem(tokenKey, token_4);
                }
                return [new State(state.IsInTestphase, state.CurrentUrl, new RequestedValue$1(1, [tokenData_1]), state.Configuration, state.AccountSettings, state.CurrentUser, state.Permissions, state.UserAccountExists, state.HealthFetched, state.OnboardingWizardCompleted, state.NavigateToLandingPage, state.HubSpotChatSettings), Cmd_none()];
            }
        }
        case 5: {
            resetToken(undefined);
            return [new State(state.IsInTestphase, state.CurrentUrl, new RequestedValue$1(1, [undefined]), state.Configuration, state.AccountSettings, state.CurrentUser, new RequestedValue$1(0, []), state.UserAccountExists, state.HealthFetched, false, false, undefined), Cmd_ofEffect((_arg_6) => {
                hide();
            })];
        }
        case 7: {
            const configuration = msg.fields[0];
            const matchValue_5 = configuration.CustomI18nextNamespace;
            if (matchValue_5 == null) {
            }
            else {
                const customI18nextNamespace = matchValue_5;
                i18next.setDefaultNamespace(customI18nextNamespace);
            }
            return [new State(state.IsInTestphase, state.CurrentUrl, state.UserData, new RequestedValue$1(1, [configuration]), state.AccountSettings, state.CurrentUser, state.Permissions, state.UserAccountExists, state.HealthFetched, state.OnboardingWizardCompleted, state.NavigateToLandingPage, state.HubSpotChatSettings), Cmd_none()];
        }
        case 8: {
            const accountSettings = msg.fields[0];
            const matchValue_6 = accountSettings.AccountState;
            switch (matchValue_6) {
                case "testPeriodOnboarding": {
                    let endDate;
                    const matchValue_7 = accountSettings.AccountEndDate;
                    endDate = ((matchValue_7 == null) ? toLocalTime(date_2(utcNow())) : toLocalTime(matchValue_7));
                    if (state.OnboardingWizardCompleted) {
                        return [new State([true, endDate], state.CurrentUrl, state.UserData, state.Configuration, new RequestedValue$1(1, [accountSettings]), state.CurrentUser, state.Permissions, state.UserAccountExists, state.HealthFetched, state.OnboardingWizardCompleted, state.NavigateToLandingPage, state.HubSpotChatSettings), Cmd_none()];
                    }
                    else {
                        return [new State([true, endDate], new Url(0, [new AuthorizedUrl(97, [])]), state.UserData, state.Configuration, new RequestedValue$1(1, [accountSettings]), state.CurrentUser, state.Permissions, state.UserAccountExists, state.HealthFetched, state.OnboardingWizardCompleted, state.NavigateToLandingPage, state.HubSpotChatSettings), Cmd_ofEffect_1((_arg_7) => {
                            RouterModule_nav(singleton_1("onboarding"), 1, 1);
                        })];
                    }
                }
                case "testPeriodActive":
                    return [new State([true, (matchValue_8 = accountSettings.AccountEndDate, (matchValue_8 == null) ? toLocalTime(date_2(utcNow())) : toLocalTime(matchValue_8))], state.CurrentUrl, state.UserData, state.Configuration, new RequestedValue$1(1, [accountSettings]), state.CurrentUser, state.Permissions, state.UserAccountExists, state.HealthFetched, state.OnboardingWizardCompleted, state.NavigateToLandingPage, state.HubSpotChatSettings), Cmd_none()];
                case "testPeriodEnded":
                    return [new State(state.IsInTestphase, state.CurrentUrl, state.UserData, state.Configuration, new RequestedValue$1(1, [accountSettings]), state.CurrentUser, state.Permissions, state.UserAccountExists, state.HealthFetched, state.OnboardingWizardCompleted, state.NavigateToLandingPage, state.HubSpotChatSettings), Cmd_ofEffect_1((_arg_8) => {
                        RouterModule_nav(singleton_1("testphaseend"), 1, 1);
                    })];
                case "canceled":
                    return [new State(state.IsInTestphase, state.CurrentUrl, state.UserData, state.Configuration, new RequestedValue$1(1, [accountSettings]), state.CurrentUser, state.Permissions, state.UserAccountExists, state.HealthFetched, state.OnboardingWizardCompleted, state.NavigateToLandingPage, state.HubSpotChatSettings), Cmd_ofEffect_1((_arg_9) => {
                        RouterModule_nav(singleton_1("account-canceled"), 1, 1);
                    })];
                case "notActivated":
                    return [new State(state.IsInTestphase, state.CurrentUrl, state.UserData, state.Configuration, new RequestedValue$1(1, [accountSettings]), state.CurrentUser, state.Permissions, state.UserAccountExists, state.HealthFetched, state.OnboardingWizardCompleted, state.NavigateToLandingPage, state.HubSpotChatSettings), Cmd_ofEffect_1((_arg_10) => {
                        RouterModule_nav(singleton_1("account-not-activated"), 1, 1);
                    })];
                default:
                    return [new State([false, now()], state.CurrentUrl, state.UserData, state.Configuration, new RequestedValue$1(1, [accountSettings]), state.CurrentUser, state.Permissions, state.UserAccountExists, state.HealthFetched, state.OnboardingWizardCompleted, state.NavigateToLandingPage, state.HubSpotChatSettings), Cmd_none()];
            }
        }
        case 9: {
            const response_6 = msg.fields[0];
            if (response_6.AccountExists) {
                const tokenData_3 = readTenantFromLocalStorage(getTokenDataFromLocalStorage(undefined));
                if (tokenData_3 == null) {
                    return [state, Cmd_none()];
                }
                else {
                    const token_5 = tokenData_3;
                    if (!debugActive) {
                        initializeSentry(tokenData_3);
                    }
                    return [new State(state.IsInTestphase, state.CurrentUrl, new RequestedValue$1(1, [tokenData_3]), state.Configuration, state.AccountSettings, state.CurrentUser, state.Permissions, new RequestedValue$1(1, [response_6.AccountExists]), state.HealthFetched, state.OnboardingWizardCompleted, state.NavigateToLandingPage, state.HubSpotChatSettings), (tokenData_3 != null) ? ((userData_1 = tokenData_3, Cmd_OfPromise_either((url_9) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        let url_11;
                        return ((url_11 = addPrefix(url_9), (refreshOn_3) => fetchWithDecoder(url_11, singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response_7) => {
                            const pr_3 = response_7.arrayBuffer();
                            return pr_3.then((blob_3) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_3)), User_$reflection()));
                        }, refreshOn_3)))(true).then((_arg_11) => {
                            const result_7 = _arg_11;
                            return (result_7.tag === 1) ? (Promise.resolve((() => {
                                throw new ValidationOnGetRequest(result_7.fields[0]);
                            })())) : (Promise.resolve(result_7.fields[0]));
                        });
                    })), "/api/receivers/users/me", (Item_10) => (new Msg(11, [Item_10])), (Item_11) => (new Msg(16, [Item_11]))))) : Cmd_none()];
                }
            }
            else {
                return [new State(state.IsInTestphase, state.CurrentUrl, state.UserData, state.Configuration, state.AccountSettings, state.CurrentUser, state.Permissions, new RequestedValue$1(1, [response_6.AccountExists]), state.HealthFetched, state.OnboardingWizardCompleted, state.NavigateToLandingPage, state.HubSpotChatSettings), Cmd_ofEffect_1((_arg_12) => {
                    RouterModule_nav(singleton_1("create-account"), 1, 1);
                })];
            }
        }
        case 10: {
            const response_9 = msg.fields[0];
            if (response_9.AccountExists) {
                const tokenData_5 = readTenantFromLocalStorage(getTokenDataFromLocalStorage(undefined));
                if (!debugActive) {
                    initializeSentry(tokenData_5);
                }
                return [new State(state.IsInTestphase, state.CurrentUrl, new RequestedValue$1(1, [tokenData_5]), state.Configuration, state.AccountSettings, state.CurrentUser, state.Permissions, new RequestedValue$1(1, [response_9.AccountExists]), state.HealthFetched, state.OnboardingWizardCompleted, state.NavigateToLandingPage, state.HubSpotChatSettings), (tokenData_5 != null) ? ((userData_2 = tokenData_5, Cmd_OfPromise_either((url_12) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_14;
                    return ((url_14 = addPrefix(url_12), (refreshOn_4) => fetchWithDecoder(url_14, singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response_10) => {
                        const pr_4 = response_10.arrayBuffer();
                        return pr_4.then((blob_4) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_4)), User_$reflection()));
                    }, refreshOn_4)))(true).then((_arg_13) => {
                        const result_9 = _arg_13;
                        return (result_9.tag === 1) ? (Promise.resolve((() => {
                            throw new ValidationOnGetRequest(result_9.fields[0]);
                        })())) : (Promise.resolve(result_9.fields[0]));
                    });
                })), "/api/receivers/users/me", (Item_12) => (new Msg(12, [Item_12])), (Item_13) => (new Msg(16, [Item_13]))))) : Cmd_none()];
            }
            else {
                return [new State(state.IsInTestphase, state.CurrentUrl, state.UserData, state.Configuration, state.AccountSettings, state.CurrentUser, state.Permissions, new RequestedValue$1(1, [response_9.AccountExists]), state.HealthFetched, state.OnboardingWizardCompleted, state.NavigateToLandingPage, state.HubSpotChatSettings), Cmd_ofEffect_1((_arg_14) => {
                    RouterModule_nav(singleton_1("create-account"), 1, 1);
                })];
            }
        }
        case 11: {
            const user = msg.fields[0];
            return [new State(state.IsInTestphase, state.CurrentUrl, state.UserData, state.Configuration, state.AccountSettings, new RequestedValue$1(1, [user]), state.Permissions, state.UserAccountExists, state.HealthFetched, state.OnboardingWizardCompleted, state.NavigateToLandingPage, state.HubSpotChatSettings), Cmd_batch(ofArray([Cmd_ofEffect((_arg_15) => {
                let pr_5;
                const arg_1 = Helper_languageToString(user.Language);
                pr_5 = (i18next.changeLanguage(arg_1));
                pr_5.then();
            }), singleton_1((dispatch) => {
                dispatch(new Msg(2, []));
            }), singleton_1((dispatch_1) => {
                dispatch_1(new Msg(1, []));
            }), Cmd_OfPromise_either((url_15) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_17;
                return ((url_17 = addPrefix(url_15), (refreshOn_5) => fetchWithDecoder(url_17, singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response_12) => {
                    const pr_6 = response_12.arrayBuffer();
                    return pr_6.then((blob_5) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_5)), option_type(HubSpotChatSettingsDto_$reflection())));
                }, refreshOn_5)))(true).then((_arg_16) => {
                    const result_11 = _arg_16;
                    return (result_11.tag === 1) ? (Promise.resolve((() => {
                        throw new ValidationOnGetRequest(result_11.fields[0]);
                    })())) : (Promise.resolve(result_11.fields[0]));
                });
            })), "/api/support/hubspot-chat", (Item_14) => (new Msg(14, [Item_14])), (Item_15) => (new Msg(16, [Item_15])))]))];
        }
        case 12: {
            const user_1 = msg.fields[0];
            return [new State(state.IsInTestphase, state.CurrentUrl, state.UserData, state.Configuration, state.AccountSettings, new RequestedValue$1(1, [user_1]), state.Permissions, state.UserAccountExists, state.HealthFetched, state.OnboardingWizardCompleted, state.NavigateToLandingPage, state.HubSpotChatSettings), Cmd_batch(ofArray([Cmd_ofEffect((_arg_17) => {
                let pr_7;
                const arg_2 = Helper_languageToString(user_1.Language);
                pr_7 = (i18next.changeLanguage(arg_2));
                pr_7.then();
            }), singleton_1((dispatch_2) => {
                dispatch_2(new Msg(1, []));
            }), Cmd_OfPromise_either((url_18) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_20;
                return ((url_20 = addPrefix(url_18), (refreshOn_6) => fetchWithDecoder(url_20, singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response_14) => {
                    const pr_8 = response_14.arrayBuffer();
                    return pr_8.then((blob_6) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_6)), option_type(HubSpotChatSettingsDto_$reflection())));
                }, refreshOn_6)))(true).then((_arg_18) => {
                    const result_13 = _arg_18;
                    return (result_13.tag === 1) ? (Promise.resolve((() => {
                        throw new ValidationOnGetRequest(result_13.fields[0]);
                    })())) : (Promise.resolve(result_13.fields[0]));
                });
            })), "/api/support/hubspot-chat", (Item_16) => (new Msg(14, [Item_16])), (Item_17) => (new Msg(16, [Item_17])))]))];
        }
        case 13: {
            const permissions_1 = msg.fields[0];
            return [new State(state.IsInTestphase, state.CurrentUrl, state.UserData, state.Configuration, state.AccountSettings, state.CurrentUser, new RequestedValue$1(1, [permissions_1]), state.UserAccountExists, state.HealthFetched, state.OnboardingWizardCompleted, false, state.HubSpotChatSettings), state.NavigateToLandingPage ? ((fullPath_14 = landingPage(permissions_1), Cmd_ofEffect_1((_arg_19) => {
                RouterModule_nav(singleton_1(fullPath_14), 1, 1);
            }))) : Cmd_none()];
        }
        case 14: {
            const matchValue_9 = state.UserData;
            let matchResult_1;
            if (matchValue_9.tag === 1) {
                if (matchValue_9.fields[0] != null) {
                    matchResult_1 = 0;
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0:
                    return [new State(state.IsInTestphase, state.CurrentUrl, state.UserData, state.Configuration, state.AccountSettings, state.CurrentUser, state.Permissions, state.UserAccountExists, state.HealthFetched, state.OnboardingWizardCompleted, state.NavigateToLandingPage, msg.fields[0]), Cmd_none()];
                default:
                    return [state, Cmd_none()];
            }
        }
        case 6: {
            const nextUrl = msg.fields[0];
            const matchValue_10 = state.AccountSettings;
            if (matchValue_10.tag === 0) {
                return [new State(state.IsInTestphase, nextUrl, state.UserData, state.Configuration, state.AccountSettings, state.CurrentUser, state.Permissions, state.UserAccountExists, state.HealthFetched, state.OnboardingWizardCompleted, state.NavigateToLandingPage, state.HubSpotChatSettings), Cmd_none()];
            }
            else {
                const matchValue_11 = matchValue_10.fields[0].AccountState;
                switch (matchValue_11) {
                    case "active":
                    case "testPeriodActive":
                        return [new State(state.IsInTestphase, nextUrl, state.UserData, state.Configuration, state.AccountSettings, state.CurrentUser, state.Permissions, state.UserAccountExists, state.HealthFetched, state.OnboardingWizardCompleted, state.NavigateToLandingPage, state.HubSpotChatSettings), Cmd_none()];
                    case "testPeriodEnded":
                        if (!equals(nextUrl, new Url(0, [new AuthorizedUrl(141, [])]))) {
                            return [state, Cmd_ofEffect_1((_arg_21) => {
                                RouterModule_nav(singleton_1("testphaseend"), 1, 1);
                            })];
                        }
                        else {
                            return [new State(state.IsInTestphase, nextUrl, state.UserData, state.Configuration, state.AccountSettings, state.CurrentUser, state.Permissions, state.UserAccountExists, state.HealthFetched, state.OnboardingWizardCompleted, state.NavigateToLandingPage, state.HubSpotChatSettings), Cmd_none()];
                        }
                    case "canceled":
                        if (!equals(nextUrl, new Url(0, [new AuthorizedUrl(142, [])]))) {
                            return [state, Cmd_ofEffect_1((_arg_22) => {
                                RouterModule_nav(singleton_1("account-canceled"), 1, 1);
                            })];
                        }
                        else {
                            return [new State(state.IsInTestphase, nextUrl, state.UserData, state.Configuration, state.AccountSettings, state.CurrentUser, state.Permissions, state.UserAccountExists, state.HealthFetched, state.OnboardingWizardCompleted, state.NavigateToLandingPage, state.HubSpotChatSettings), Cmd_none()];
                        }
                    case "notActivated":
                        if (!equals(nextUrl, new Url(0, [new AuthorizedUrl(143, [])]))) {
                            return [state, Cmd_ofEffect_1((_arg_23) => {
                                RouterModule_nav(singleton_1("account-not-activated"), 1, 1);
                            })];
                        }
                        else {
                            return [new State(state.IsInTestphase, nextUrl, state.UserData, state.Configuration, state.AccountSettings, state.CurrentUser, state.Permissions, state.UserAccountExists, state.HealthFetched, state.OnboardingWizardCompleted, state.NavigateToLandingPage, state.HubSpotChatSettings), Cmd_none()];
                        }
                    default:
                        if (state.OnboardingWizardCompleted) {
                            return [new State(state.IsInTestphase, nextUrl, state.UserData, state.Configuration, state.AccountSettings, state.CurrentUser, state.Permissions, state.UserAccountExists, state.HealthFetched, state.OnboardingWizardCompleted, state.NavigateToLandingPage, state.HubSpotChatSettings), Cmd_none()];
                        }
                        else if (nextUrl.tag === 1) {
                            return [new State(state.IsInTestphase, nextUrl, state.UserData, state.Configuration, state.AccountSettings, state.CurrentUser, state.Permissions, state.UserAccountExists, state.HealthFetched, state.OnboardingWizardCompleted, state.NavigateToLandingPage, state.HubSpotChatSettings), Cmd_none()];
                        }
                        else if (nextUrl.fields[0].tag === 97) {
                            return [new State(state.IsInTestphase, nextUrl, state.UserData, state.Configuration, state.AccountSettings, state.CurrentUser, state.Permissions, state.UserAccountExists, state.HealthFetched, state.OnboardingWizardCompleted, state.NavigateToLandingPage, state.HubSpotChatSettings), Cmd_none()];
                        }
                        else {
                            return [new State(state.IsInTestphase, new Url(0, [new AuthorizedUrl(97, [])]), state.UserData, state.Configuration, state.AccountSettings, state.CurrentUser, state.Permissions, state.UserAccountExists, state.HealthFetched, state.OnboardingWizardCompleted, state.NavigateToLandingPage, state.HubSpotChatSettings), Cmd_ofEffect_1((_arg_20) => {
                                RouterModule_nav(singleton_1("onboarding"), 1, 1);
                            })];
                        }
                }
            }
        }
        case 15:
            return [new State(state.IsInTestphase, state.CurrentUrl, state.UserData, state.Configuration, state.AccountSettings, state.CurrentUser, state.Permissions, state.UserAccountExists, new RequestedValue$1(1, [true]), state.OnboardingWizardCompleted, state.NavigateToLandingPage, state.HubSpotChatSettings), Cmd_none()];
        case 16:
            return [state, Cmd_none()];
        case 17: {
            let patternInput;
            const matchValue_12 = state.Permissions;
            let matchResult_2, permissions_3;
            if (matchValue_12.tag === 1) {
                if (!canSeeDashboard(matchValue_12.fields[0])) {
                    matchResult_2 = 0;
                    permissions_3 = matchValue_12.fields[0];
                }
                else {
                    matchResult_2 = 1;
                }
            }
            else {
                matchResult_2 = 1;
            }
            switch (matchResult_2) {
                case 0: {
                    patternInput = [new Url(0, [new AuthorizedUrl(13, [])]), Cmd_ofEffect_1((_arg_24) => {
                        RouterModule_nav(singleton_1("tools"), 1, 1);
                    })];
                    break;
                }
                default:
                    patternInput = [new Url(0, [new AuthorizedUrl(0, [])]), Cmd_ofEffect_1((_arg_25) => {
                        RouterModule_nav(singleton_1("dashboard"), 1, 1);
                    })];
            }
            return [new State(state.IsInTestphase, patternInput[0], state.UserData, state.Configuration, state.AccountSettings, state.CurrentUser, state.Permissions, state.UserAccountExists, state.HealthFetched, true, state.NavigateToLandingPage, state.HubSpotChatSettings), Cmd_batch(ofArray([patternInput[1], singleton_1((dispatch_3) => {
                dispatch_3(new Msg(1, []));
            })]))];
        }
        default:
            return [state, Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_2;
                return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
                    const pr = response.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), Requests_UserAccountExistsResponse_$reflection()));
                }, refreshOn)))(true).then((_arg) => {
                    const result_1 = _arg;
                    return (result_1.tag === 1) ? (Promise.resolve((() => {
                        throw new ValidationOnGetRequest(result_1.fields[0]);
                    })())) : (Promise.resolve(result_1.fields[0]));
                });
            })), "/api/users/account-exists", (Item) => (new Msg(9, [Item])), (Item_1) => (new Msg(16, [Item_1])))];
    }
}

export function View(viewInputProps) {
    let elems_1, props_3, children_2, props_2, children_1;
    const dispatch = viewInputProps.dispatch;
    const state = viewInputProps.state;
    const patternInput = useTranslation();
    let onLogout;
    const dependencies_1 = [state.UserData];
    onLogout = reactApi.useCallback(() => {
        dispatch(new Msg(5, []));
    }, dependencies_1);
    const parseToken_1 = reactApi.useCallback(() => {
        dispatch(new Msg(3, []));
    }, []);
    const parseTokenFromParam = reactApi.useCallback(() => {
        dispatch(new Msg(4, []));
    }, []);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "h-full", "font-inter", "flex-col"])], (elems_1 = [(props_3 = ofArray([["userManager", userManager], ["onSigninCallback", (value_2) => {
        if (value_2 == null) {
        }
        else {
            dispatch(new Msg(0, [value_2.access_token]));
        }
    }], (children_2 = singleton_1((props_2 = ofArray([["backend", html5Backend], (children_1 = toList(delay(() => {
        let inputProperties, elements_2;
        return patternInput[2] ? singleton((inputProperties = createObj(ofArray([["key", "dnd-provider-swr-config-key"], ["value", {
            dedupingInterval: 10000,
            provider: localStorageProvider,
            revalidateOnFocus: false,
        }], (elements_2 = ofArray([createElement(Toaster, null), RouterModule_router(createObj(toList(delay(() => append(singleton(["onUrlChanged", (segments) => {
            rememberCurrentRoute();
            dispatch(new Msg(6, [parseUrl(segments)]));
        }]), delay(() => {
            let elements, elements_1, props, children;
            return debugActive ? singleton((elements = singleton_1(createElement(ActivePage, {
                AccountSettings: state.AccountSettings,
                Configuration: state.Configuration,
                CurrentUrl: state.CurrentUrl,
                CurrentUser: state.CurrentUser,
                HealthFetched: state.HealthFetched,
                HubSpotChatSettings: unwrap(state.HubSpotChatSettings),
                IsInTestphase: state.IsInTestphase,
                OnConfigurationChanged: () => {
                    dispatch(new Msg(1, []));
                },
                OnLogout: onLogout,
                OnWizardCompleted: () => {
                    dispatch(new Msg(17, []));
                },
                OnboardingWizardCompleted: state.OnboardingWizardCompleted,
                ParseToken: parseToken_1,
                ParseTokenFromParam: parseTokenFromParam,
                Permissions: state.Permissions,
                UserData: state.UserData,
            })), ["application", react.createElement(react.Fragment, {}, ...elements)])) : singleton((elements_1 = singleton_1((props = singleton_1((children = singleton_1(createElement(ActivePage, {
                AccountSettings: state.AccountSettings,
                Configuration: state.Configuration,
                CurrentUrl: state.CurrentUrl,
                CurrentUser: state.CurrentUser,
                HealthFetched: state.HealthFetched,
                HubSpotChatSettings: unwrap(state.HubSpotChatSettings),
                IsInTestphase: state.IsInTestphase,
                OnConfigurationChanged: () => {
                    dispatch(new Msg(1, []));
                },
                OnLogout: onLogout,
                OnWizardCompleted: () => {
                    dispatch(new Msg(17, []));
                },
                OnboardingWizardCompleted: state.OnboardingWizardCompleted,
                ParseToken: parseToken_1,
                ParseTokenFromParam: parseTokenFromParam,
                Permissions: state.Permissions,
                UserData: state.UserData,
            })), ["children", reactApi_1.Children.toArray(children)])), reactApi_1.createElement(ErrorBoundary, createObj(props)))), ["application", react.createElement(react.Fragment, {}, ...elements_1)]));
        }))))))]), ["children", reactApi.Children.toArray(Array.from(elements_2))])])), reactApi_1.createElement(SWRConfig, inputProperties))) : singleton(createElement(LoadingPage, null));
    })), ["children", reactApi_1.Children.toArray(children_1)])]), reactApi_1.createElement(DndProvider, createObj(props_2)))), ["children", reactApi_1.Children.toArray(children_2)])]), reactApi_1.createElement(AuthProvider, createObj(props_3)))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

if (debugActive) {
    ProgramModule_run((() => {
        let copyOfStruct, copyOfStruct_1, copyOfStruct_2;
        const program_3 = Program_withReactBatched("elmish-app", ProgramModule_withConsoleTrace(ProgramModule_mkProgram(init, update, (state_1, dispatch) => createElement(View, {
            state: state_1,
            dispatch: dispatch,
        }))));
        const options = {};
        const program_5 = program_3;
        try {
            let patternInput;
            try {
                let coders;
                let extra_2_1;
                const extra_1_1 = new ExtraCoders((copyOfStruct = newGuid(), copyOfStruct), add("System.Decimal", [decimal, (path) => ((value_1) => decimal_1(path, value_1))], empty_1.Coders));
                extra_2_1 = (new ExtraCoders((copyOfStruct_1 = newGuid(), copyOfStruct_1), add("System.Int64", [int64, int64_1], extra_1_1.Coders)));
                coders = (new ExtraCoders((copyOfStruct_2 = newGuid(), copyOfStruct_2), add("System.UInt64", [uint64, uint64_1], extra_2_1.Coders)));
                const encoder_3 = Auto_generateBoxedEncoder_437914C6(State_$reflection(), undefined, coders, undefined);
                const decoder_3 = Auto_generateBoxedDecoder_Z6670B51(State_$reflection(), undefined, coders);
                patternInput = [(x) => {
                    try {
                        return encoder_3(x);
                    }
                    catch (er) {
                        Debugger_showWarning(singleton_1(er.message));
                        return x;
                    }
                }, (x_1) => {
                    const matchValue = fromValue("$", uncurry2(decoder_3), x_1);
                    if (matchValue.tag === 1) {
                        throw new Exception(matchValue.fields[0]);
                    }
                    else {
                        return matchValue.fields[0];
                    }
                }];
            }
            catch (er_2) {
                Debugger_showWarning(singleton_1(er_2.message));
                patternInput = [(value_7) => value_7, (_arg) => {
                    throw new Exception("Cannot inflate model");
                }];
            }
            const deflater_1 = patternInput[0];
            const inflater_1 = patternInput[1];
            let connection_1;
            const options_1 = options;
            const actionCreators = map_3((case$) => ({
                args: map_3(name_1, getUnionCaseFields(case$)),
                name: name_1(case$),
            }), getUnionCases(Msg_$reflection()));
            options_1.getActionType = (Debugger_getCase);
            if (options_1.actionCreators == null) {
                options_1.actionCreators = actionCreators;
            }
            connection_1 = (window.__REDUX_DEVTOOLS_EXTENSION__.connect(options_1));
            const program_6 = program_5;
            return ProgramModule_mapErrorHandler((userOnError, tupledArg) => {
                const text = tupledArg[0];
                const ex_1 = tupledArg[1];
                userOnError([text, ex_1]);
                connection_1.error(text + ex_1.message);
            }, ProgramModule_map((userInit, a) => {
                const patternInput_1 = userInit();
                const model = patternInput_1[0];
                connection_1.init(deflater_1(model), undefined);
                return [model, patternInput_1[1]];
            }, (userUpdate, msg_1, model_1) => {
                const patternInput_1_1 = userUpdate(msg_1)(model_1);
                const model$0027 = patternInput_1_1[0];
                connection_1.send(msg_1, deflater_1(model$0027));
                return [model$0027, patternInput_1_1[1]];
            }, uncurry3((x_1_1) => x_1_1), uncurry3((x_2_1) => x_2_1), (userSubscribe, model_2) => Sub_batch(ofArray([singleton_1([singleton_1("debugger"), (dispatch_1) => {
                const unsub = connection_1.subscribe((_arg_1) => {
                    let name, args;
                    switch (_arg_1.type) {
                        case "ACTION": {
                            const msg_3 = _arg_1;
                            dispatch_1((name = msg_3.payload.name, (args = msg_3.payload.args, makeUnion(FSharpMap__get_Item(ofSeq(toList(delay(() => map_2((case$_1) => [name_1(case$_1), case$_1], getUnionCases(Msg_$reflection())))), {
                                Compare: (x_4, y) => (comparePrimitives(x_4, y) | 0),
                            }), name), args))));
                            break;
                        }
                        case "DISPATCH": {
                            const msg_4 = _arg_1;
                            try {
                                const matchValue_1 = msg_4.payload.type;
                                switch (matchValue_1) {
                                    case "JUMP_TO_ACTION":
                                    case "JUMP_TO_STATE": {
                                        const state_2 = inflater_1(extractState(msg_4));
                                        ProgramModule_setState(program_6)(state_2)(dispatch_1);
                                        break;
                                    }
                                    case "IMPORT_STATE": {
                                        const state_1_1 = last(msg_4.payload.nextLiftedState.computedStates);
                                        const state_2_1 = inflater_1(state_1_1.state);
                                        ProgramModule_setState(program_6)(state_2_1)(dispatch_1);
                                        connection_1.send(defaultOf(), msg_4.payload.nextLiftedState);
                                        break;
                                    }
                                    default:
                                        undefined;
                                }
                            }
                            catch (ex) {
                                Debugger_showError(ofArray(["Unable to process monitor command", ex.message, msg_4]));
                            }
                            break;
                        }
                        default:
                            undefined;
                    }
                });
                return {
                    Dispose() {
                        unsub();
                    },
                };
            }]), Sub_map("user", (x_5) => x_5, userSubscribe(model_2))])), (tupledArg_1) => [tupledArg_1[0], tupledArg_1[1]], program_6));
        }
        catch (ex_2) {
            Debugger_showError(ofArray(["Unable to connect to the monitor, continuing w/o debugger", ex_2.message]));
            return program_5;
        }
    })());
}
else {
    ProgramModule_run(Program_withReactBatched("elmish-app", ProgramModule_mkProgram(init, update, (state_4, dispatch_2) => createElement(View, {
        state: state_4,
        dispatch: dispatch_2,
    }))));
}

